<template>
	<div>
		<div class="container-fluid container-home vertical-center">
			<div class="container">
				<da-welcome></da-welcome>
			</div>
		</div>
		<div class="container container-publications">
			<div class="row">
				<da-publications></da-publications>
			</div>
		</div>
	</div>
</template>

<script>
	import DaWelcome from './Welcome.vue'
	import DaPublications from './Publications.vue'


	export default {
		name: 'index',
		components: { DaWelcome, DaPublications },
		data() {
			return {
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../scss/abstracts/variables';
	.container-publications {
		margin-bottom: 2rem;
	}
	.container-home {
		padding-top: 2rem;
		padding-bottom: 2rem;
		background: 
			linear-gradient(
				90deg,
				rgba(248, 249, 250, 0.85) 90%,
				rgba(248, 249, 250, 0.85) 100%),
				url(../../src/assets/fondo.svg
			) center right no-repeat;
		
		@include media-breakpoint-up(sm) {      
			padding-top: 3rem;
			padding-bottom: 3rem;
			background: 
				linear-gradient(
					90deg,
					rgba(248, 249, 250, 0.7) 90%,
					rgba(248, 249, 250, 0.6) 100%),
					url(../../src/assets/fondo.svg
				) center right no-repeat;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue